import { React, useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import Listing from './listing';
import Survey from './survey';
import ReportOne from './report';
import ReportTwo from './reportTwo';
import moment from 'moment';

const PropertyTour = () => {
    const apiService = new LeaseApiService();
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false]);
    const [listProperty, setlistProperty] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [customerList, setCustomerLIst] = useState([]);
    const [landloardList, setLandloard] = useState([]);
    const [scheduleList, setScheduleList] = useState([]);
    const [statusLIst, setStatusList] = useState([]);
    const [surveyList, setSurveeyList] = useState([]);
    const [reportList, setreportList] = useState([]);
    const [reportTwo, setReportTwo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [isEdit, setIsEdit] = useState(false);
    const [isEditData, setIsEditData] = useState();

    const [visitor, setVisitor] = useState({
        name: "",
        contact: "",
        phone: "",
        email: "",
        sms: "",
        data: {},
        cc: "",
    });

    useEffect(() => {
        fetchDropdownData();
        getItems()
    }, [])

    useEffect(() => {
        if (isEdit === true) {
            editDataSet()
        }
    }, [isEdit])

    const editDataSet = async () => {
        try {
            const params = new URLSearchParams();
            params.append('Action', 'GetPropertyTourMasterByScheduleId');
            params.append('LeaseNo', isEditData?.scheduleId);
            const res = await apiService.getApiParamater('COMMON_PROPRTYTOUR', `?${params.toString()}`);
            let result = res?.data?.result?.data
            setVisitor(prev => ({
                ...prev,
                name: result?.CustName ? { label: result.CustName || null, value: result?.CustName || null } : null,
                contact: result?.Cont ? { label: result.Cont || null, value: result?.Cont || null } : null,
                phone: result?.Phone || "",
                email: result?.Email || "",
                sms: result?.SMS || "",
                data: result,
            }));
            const listparams = new URLSearchParams();
            listparams.append('Action', 'GetPropertyTourDetailsByScheduleId');
            listparams.append('LeaseNo', isEditData?.rowNumber);
            const listRes = await apiService.getApiParamater('COMMON_PROPRTYTOUR', `?${listparams.toString()}`);
            let listresult = listRes?.data?.result?.data
            const normalizeArray = (data) =>
                Array.isArray(data) ? data : data ? [data] : [];
            const rawContactData = normalizeArray(listresult);
            const mappedContacts = rawContactData?.map(item => ({
                property: item?.Property || null,
                unit: item?.Unit || null,
                agent: item?.Agent || null,
                status: item?.Status || null,
                date: moment(item?.SchDate).format("DD-MMM-YYYY") || "",
                from: item?.SchFromTime ? moment(item.SchFromTime, "HH:mm:ss").format("hh:mm A") : "",
                to: item?.SchToTime ? moment(item.SchToTime, "HH:mm:ss").format("hh:mm A") : "",
                remarks: item?.Remarks || "",
                recordId: item?.RecordID,
            }));
            setSurveeyList(mappedContacts)
            handleTabClick(1)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'PTProperties,PTCustomers,PTAgents,PTStatuses,PTScheduleIds,PTLandlords');
            const res = await apiService.getApiParamater('MULTI_PROPRTYTOUR', `?${params.toString()}`);
            setlistProperty(res?.data?.dropdowns?.PTProperties);
            setStatusList(res?.data?.dropdowns?.PTStatuses);
            setScheduleList(res?.data?.dropdowns?.PTScheduleIds)
            setAgentList(res?.data?.dropdowns?.PTAgents)
            setCustomerLIst(res?.data?.dropdowns?.PTCustomers)
            setLandloard(res?.data?.dropdowns?.PTLandlords)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            const res = await apiService.getApiParamater('GET_PROPRTYTOUR', `?${params.toString()}`);
            setLoading(false)
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false)
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    return (
        <div className="p-3">
            <div className='mb-3'><h6>Property Tour</h6></div>
            <div className='border-box2  p-2' style={{ borderRadius: "8px" }}>
                <div className='col-lg-8 nav nav-pills overslid d-flex gap-4'>
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        Listing
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Schedule Survey
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)}
                    >
                        Report
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(3)}
                    >
                        Individual Report
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <Listing loading={loading} setIsEditData={setIsEditData} setIsEdit={setIsEdit} pagination={pagination} pageSize={pageSize} rowData={rowData} setPageSize={setPageSize} getItems={getItems} />
            )}
            {gridVisibility[1] && (
                <Survey isEdit={isEdit} setIsEdit={setIsEdit} setIsEditData={setIsEditData} setSurveeyList={setSurveeyList} surveyList={surveyList} setVisitor={setVisitor} visitor={visitor} pageSize={pageSize}
                    rowData={rowData} setPageSize={setPageSize} getItems={getItems} listProperty={listProperty} agentList={agentList} customerList={customerList}
                    scheduleList={scheduleList} statusLIst={statusLIst} isEditData={isEditData} />
            )}
            {gridVisibility[2] && (
                <ReportOne setreportList={setreportList} reportList={reportList} listProperty={listProperty} agentList={agentList} scheduleList={scheduleList} statusLIst={statusLIst} />
            )}
            {gridVisibility[3] && (
                <ReportTwo setreportList={setReportTwo} reportList={reportTwo} listProperty={listProperty} statusLIst={statusLIst} landloardList={landloardList} />
            )}
        </div >
    );
};

export default PropertyTour;